module.exports = __webpack_public_path__ + "img/012.8c33d814.png";